import React, { useRef, useState, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  ZoomControl,
  GeoJSON,
  Tooltip,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useContext } from "react";
import { MapContext } from "../../Context/OptionsApi";
import Apple from "../../assets/Apple.jsx";
import Cotton from "../../assets/Cotton.jsx";
import Paddy from "../../assets/Paddy.jsx";
import location from "../../assets/location.svg";
import L from "leaflet";
import indiaGeoJSON from "../../geojson/help.json";
import { AppContext } from "../../Context/Context.js";
const baseURL1 = process.env.REACT_APP_BASE_URL_APP;
export default function CropCountmap(props) {
  const { filters } = useContext(MapContext);
  const [openPopups, setOpenPopups] = useState(true);
  const [cropCountData, setCropCountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const {user} = useContext(AppContext);
  const mapRef = useRef();
  const createIcon = (iconUrl) => {
    return new L.Icon({
      iconUrl,
      iconSize: [25, 25], // Set the size of the icon
      iconAnchor: [12, 12], // Adjust this to center the icon
      popupAnchor: [0, -12], // Position the popup relative to the marker
    });
  };

  const indiaBounds = [
    [6.5546079, 68.1113787], // Southwest corner
    [35.6745457, 97.395561], // Northeast corner
  ];
  const india_style = {
    color: "black",
    weight: 1,
    fillColor: "#eff6ff",
    fillOpacity: 0.1,
  };

  useEffect(() => {
    const fetchCropCountData = async (clientName) => {

      try {
        const token=user?.token;
        const response = await fetch(
        `${baseURL1}/api/user/cropcountlog?clientName=${clientName}`,
        {headers: {"Authorization": `Bearer ${token}`}});

        const responseData = await response.json();
        if (!response.ok) {
            let errorMessage=responseData?.error||"could not fetch Crop Count log";
            setError(errorMessage);
        }else{
            setCropCountData(responseData);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCropCountData(user?.clientName);
  }, []);
  if (loading) {
    return <div className="p-2 mx-auto w-fit">Loading...</div>;
  }

  if (error) {
    return <div className="p-2 mx-auto w-fit">Error: {error}</div>;
  }
  return (
    <>
      <div className="flex grow mx-5 justify-center relative">
        <div className="w-[50%] relative border-2 border-gray-400 rounded-md  flex flex-col justify-between">
          <MapContainer
            center={[filters.lat, filters.lon]}
            zoom={4.5}
            maxBounds={indiaBounds}
            style={{ height: `100%`, width: "100%" }}
            zoomControl={false}
            whenReady={(mapInstance) => {
              mapRef.current = mapInstance;
            }}
          >
            <TileLayer
              // url="http://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
              // subdomains={["mt0", "mt1", "mt2", "mt3"]}
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <GeoJSON data={indiaGeoJSON.geojson} style={india_style} />

            {cropCountData.map((el, i) => {
              const baseLat = el.latitude;
              const baseLng = el.longitude;

              return (
                <React.Fragment key={i}>
                  <Marker
                    key={`${i}-paddy`}
                    position={{
                      lat: baseLat,
                      lng: baseLng,
                    }}
                    icon={createIcon(location)}
                  >
                    <Tooltip
                      direction="bottom"
                      offset={[0, 15]}
                      opacity={1}
                      permanent
                    >
                      <div className="flex justify-center gap-2">
                        {el.Paddy ? (
                          <div className="flex  items-center gap-1 font-semibold">
                            <Paddy width={20} height={20} />
                            {el.Paddy}
                          </div>
                        ) : null}
                        {el.Cotton ? (
                          <div className="flex  items-center gap-1 font-semibold">
                            <Cotton width={20} height={20} />
                            {el.Cotton}
                          </div>
                        ) : null}
                        {el.Apple ? (
                          <div className="flex  items-center gap-1 font-semibold">
                            <Apple width={20} height={20} /> {el.Apple}
                          </div>
                        ) : null}
                      </div>
                      <div className="text-center text-xs font-semibold">
                        {" "}
                        {el.state}
                      </div>
                    </Tooltip>
                  </Marker>

                  </React.Fragment>

              );
            })}
            {/* {data.map((el, i) => {
              const baseLat = el.latitude;
              const baseLng = el.longitude;

              return (
                <>
                  
                  <Marker
                    key={`${i}-paddy`}
                    position={{
                      lat: baseLat,
                      lng: baseLng,
                    }}
                    icon={createIcon(paddy)}
                  >
                    <Popup>
                      <h3>{el.state}</h3>
                      <p>Paddy: {el.Paddy}</p>
                    </Popup>
                  </Marker>

                  
                  <Marker
                    key={`${i}-cotton`}
                    position={{
                      lat: baseLat + 0.4, // Adjust latitude slightly
                      lng: baseLng + 0.4, // Adjust longitude slightly
                    }}
                    icon={createIcon(cotton)}
                  >
                    <Popup>
                      <h3>{el.state}</h3>
                      <p>Cotton: {el.Cotton}</p>
                    </Popup>
                  </Marker>

                  
                  <Marker
                    key={`${i}-apple`}
                    position={{
                      lng: baseLng - 0.4,  
                      lat: baseLat - 0.4,  
                    }}
                    icon={createIcon(apple)}
                  >
                    <Popup>
                      <h3>{el.state}</h3>
                      <p>Apple: {el.Apple}</p>
                    </Popup>
                  </Marker>
                </>
              );
            })} */}
            <ZoomControl position="topright" />
          </MapContainer>
        </div>
      </div>
    </>
  );
}
